class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      if (typeof window._cthCheckMilestoneGift === 'function') {
        window._cthCheckMilestoneGift();
      }
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      if (typeof window._cthCheckMilestoneGift === 'function') {
        window._cthCheckMilestoneGift(parsedState);
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

let isMilestoneGiftSyncing = false;

function getMilestoneGiftConfig() {
  let enabled = true;
  let giftVariantId = 67489383940386;
  let giftThreshold = 199900;
  let discountCode1 = 'Rs 50 OFF';
  let discountCode2 = 'Rs 100 OFF';

  if (window.themeMilestoneConfig) {
    if (typeof window.themeMilestoneConfig.enabled !== 'undefined') {
      enabled = Boolean(window.themeMilestoneConfig.enabled);
    }
    if (window.themeMilestoneConfig.giftVariantId) {
      giftVariantId = Number(window.themeMilestoneConfig.giftVariantId);
    }
    if (window.themeMilestoneConfig.threshold4) {
      giftThreshold = Number(window.themeMilestoneConfig.threshold4);
    }
    if (window.themeMilestoneConfig.discountCode1) {
      discountCode1 = String(window.themeMilestoneConfig.discountCode1);
    }
    if (window.themeMilestoneConfig.discountCode2) {
      discountCode2 = String(window.themeMilestoneConfig.discountCode2);
    }
  }

  const drawerEl = document.querySelector('#CartDrawer') || document.querySelector('cart-drawer');
  if (drawerEl) {
    const enAttr = drawerEl.getAttribute('data-milestone-enabled');
    if (enAttr !== null) {
      enabled = enAttr === 'true';
    }
    const vId = Number(drawerEl.getAttribute('data-gift-variant-id'));
    const tVal = Number(drawerEl.getAttribute('data-gift-threshold'));
    if (!isNaN(vId) && vId > 0) giftVariantId = vId;
    if (!isNaN(tVal) && tVal > 0) giftThreshold = tVal;

    const d1 = drawerEl.getAttribute('data-discount-code-1');
    const d2 = drawerEl.getAttribute('data-discount-code-2');
    if (d1) discountCode1 = d1;
    if (d2) discountCode2 = d2;
  }

  const bar = document.querySelector('[data-milestone-bar]');
  if (bar) {
    const vId = Number(bar.getAttribute('data-gift-variant-id'));
    const tVal = Number(bar.getAttribute('data-milestone-4'));
    if (!isNaN(vId) && vId > 0) giftVariantId = vId;
    if (!isNaN(tVal) && tVal > 0) giftThreshold = tVal;
  }

  return { enabled, giftVariantId, giftThreshold, discountCode1, discountCode2 };
}

async function checkMilestoneGift(cartData) {
  if (isMilestoneGiftSyncing) return;

  try {
    let cart = cartData;
    if (!cart || !Array.isArray(cart.items) || typeof cart.items_subtotal_price === 'undefined') {
      const res = await fetch((window.routes ? window.routes.cart_url : '/cart') + '.js', {
        headers: { Accept: 'application/json' },
      });
      cart = await res.json();
    }

    if (!cart || !Array.isArray(cart.items)) return;

    const { enabled, giftVariantId, giftThreshold, discountCode1, discountCode2 } = getMilestoneGiftConfig();
    if (!enabled || !giftVariantId) return;

    const giftItem = cart.items.find((item) => {
      const vId = Number(item.variant_id || (item.variant && item.variant.id) || item.id);
      const isMilestoneReward = item.properties && item.properties._milestone_reward === 'true';
      return vId === giftVariantId || isMilestoneReward;
    });
    const hasCurrentGift = giftItem && Number(giftItem.variant_id || (giftItem.variant && giftItem.variant.id) || giftItem.id) === giftVariantId;
    const hasAnyGift = !!giftItem;

    let qualifyingSubtotal = 0;
    cart.items.forEach((item) => {
      const vId = Number(item.variant_id || (item.variant && item.variant.id) || item.id);
      const isMilestoneReward = item.properties && item.properties._milestone_reward === 'true';
      if (vId !== giftVariantId && !isMilestoneReward) {
        qualifyingSubtotal += Number(item.final_line_price || (item.price * item.quantity));
      }
    });

    const qualifies = qualifyingSubtotal >= giftThreshold;
    const cartDrawer = document.querySelector('cart-drawer');
    const sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];

    if (qualifies) {
      const appliedDiscounts = [];
      if (Array.isArray(cart.cart_level_discount_applications)) {
        appliedDiscounts.push(...cart.cart_level_discount_applications.map((d) => d.title));
      }
      if (Array.isArray(cart.discount_applications)) {
        appliedDiscounts.push(...cart.discount_applications.map((d) => d.title || d.code));
      }
      if (Array.isArray(cart.discount_codes)) {
        appliedDiscounts.push(...cart.discount_codes.map((d) => d.code));
      }

      const cleanTokens = [discountCode1, discountCode2]
        .filter(Boolean)
        .flatMap((s) => s.split(','))
        .map((t) => t.trim().toLowerCase().replace(/[\s\.\-_\u20B9]/g, ''))
        .filter(Boolean);

      const hasMatchingDiscount = appliedDiscounts.some((title) => {
        if (!title) return false;
        const cleanTitle = String(title).toLowerCase().replace(/[\s\.\-_\u20B9]/g, '');
        return cleanTokens.some((tok) => cleanTitle.includes(tok));
      });

      if (hasMatchingDiscount) {
        try {
          await fetch('/discount/CLEAR', { method: 'GET', redirect: 'manual' });
        } catch (_) {}
      }
    }

    if (qualifies && !hasCurrentGift) {
      isMilestoneGiftSyncing = true;
      if (giftItem && !hasCurrentGift) {
        await fetch(window.routes ? window.routes.cart_change_url : '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            id: giftItem.key,
            quantity: 0
          })
        });
      }

      const addRes = await fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: giftVariantId,
              quantity: 1,
              properties: {
                _milestone_reward: 'true',
              },
            },
          ],
          sections: sectionsToRender,
          sections_url: window.location.pathname,
        }),
      });

      const result = await addRes.json();
      if (cartDrawer && typeof cartDrawer.renderContents === 'function' && result.sections) {
        cartDrawer.renderContents(result);
      }
    } else if (!qualifies && hasAnyGift) {
      isMilestoneGiftSyncing = true;
      const changeRes = await fetch(window.routes ? window.routes.cart_change_url : '/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          id: giftItem.key || String(giftVariantId),
          quantity: 0,
          sections: sectionsToRender,
          sections_url: window.location.pathname,
        }),
      });

      const result = await changeRes.json();
      if (cartDrawer && typeof cartDrawer.renderContents === 'function' && result.sections) {
        cartDrawer.renderContents(result);
      }
    }
  } catch (err) {
    console.error('Milestone gift auto-sync error:', err);
  } finally {
    isMilestoneGiftSyncing = false;
  }
}

window._cthCheckMilestoneGift = checkMilestoneGift;

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    checkMilestoneGift(event ? event.cartData : null);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => checkMilestoneGift());
} else {
  checkMilestoneGift();
}
